import { countriesWithCode } from "@aurem/nationalities";
import { SelectOption } from "@aurem/ui";
import { CountryCode } from "components/display/CountryCode";
import { useI18n } from "providers/I18nProvider";
import { useMemo } from "react";
import {
  citizenshipByCountryCode,
  getCountriesWithCode,
} from "utils/nationality";

export const useCountryOptions = (): SelectOption[] => {
  const { language } = useI18n();

  return useMemo(() => {
    const countryNames = getCountriesWithCode(language);

    return Object.keys(countriesWithCode)
      .filter((code) => citizenshipByCountryCode[code])
      .map((code) => ({
        id: code,
        text: countryNames[code] ?? countriesWithCode[code],
        icon: <CountryCode code={code} />,
      }))
      .sort((a, b) => a.text.localeCompare(b.text, language));
  }, [language]);
};
